import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import EberComponents from '@/components/EberModules/index.js'
import VuePhotoSwipe from '@/components/VuePhotoSwipe/index.js'
import filters from '@/filters/index.js'
import '@/plugins/element.js'
import '@/plugins/Print.js'
import '@/assets/style.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import echarts from 'echarts'
import EberEditor from '@eber/editor'
import $ from 'jquery'

Vue.prototype.$echarts = echarts;
Vue.prototype.$ = $;
Vue.config.productionTip = false
store.dispatch('clientToken')
Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]) })
Vue.use(EberComponents)
Vue.use(VuePhotoSwipe)
Vue.use(EberEditor)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
